import { useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../api/queryKeys';

/** Кто вошёл: то, что панель знает о себе после входа или восстановления. */
export type Session = { id: string; roles: string[] };

export const ADMIN_ROLE = 'admin';

export function isAdminSession(session: Session): boolean {
  return session.roles.includes(ADMIN_ROLE);
}

/**
 * Сессия из кэша запросов — единственного места, где она лежит (AD-A5). Пишет её гейт и
 * выход; экраны только читают. `enabled: false`: сама себя она не запрашивает, а `staleTime`
 * бесконечный — обновляется только записью. `null` — «вышли»: запись, а не удаление, потому
 * что удаление ключа из кэша не перерисовывает подписчиков, а запись — да.
 */
export function useSession(): Session | null | undefined {
  const { data } = useQuery<Session | null>({
    queryKey: queryKeys.me(),
    queryFn: () => Promise.reject(new Error('Сессию пишет гейт, а не запрос.')),
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return data;
}

export function useSessionWriter() {
  const queryClient = useQueryClient();
  return {
    set: (session: Session) => queryClient.setQueryData<Session | null>(queryKeys.me(), session),
    /** Сессии нет — и ничего чужого в кэше тоже: данные прежнего администратора стираются. */
    clear: () => {
      queryClient.setQueryData<Session | null>(queryKeys.me(), null);
      queryClient.removeQueries({
        predicate: (query) => query.queryKey[0] !== queryKeys.me()[0],
      });
    },
  };
}
